import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { UseAuthContext } from "../../store/contexts/auth.context";
import Box from "../../UI/Box";

function VerifyAccount() {
  const { sendVerifyCode, data, checkAccountVerify } = UseAuthContext();
  const navigate = useNavigate();
  useEffect(() => {
    if (data.is_verified) {
      return navigate("/add-post");
    }
    (async function sendCode() {
      await sendVerifyCode();
    })();
  }, []);
  const sumbit = async (e) => {
    e.preventDefault();
    const res = await checkAccountVerify(e.target.code.value);
    if (res) {
      return navigate("/add-post");
    } else {
      alert("Invalid code");
    }
  };
  return (
    <Wrapper className="flex">
      <Box>
        <form onSubmit={sumbit}>
          <p>We sent verification code to your email address</p>
          <h2>Enter verification code here:</h2>
          <input
            className="form-input"
            name="code"
            type="text"
            placeholder="AA-000"
          />
          <input className="form-input" type="submit" value={"Check"} />
        </form>
      </Box>
    </Wrapper>
  );
}

export default VerifyAccount;
const Wrapper = styled.div`
  min-height: calc(100vh - 110px);
  & > div {
    padding: 40px;
  }
  p {
    margin-bottom: 12px;
  }
`;
